@if (form) {
  @if (view$.value === 'form') {
    <div class="dialog-container">
      <!-- Header -->
      <h2 class="dialog-title">{{ data?.alert ? 'Edit' : 'Create' }} an Alert</h2>

      <!-- Icon and Name Row -->
      <div class="row">
        <task-icon-picker-button
          [iconName]="form.get('icon').value"
          [lightBackground]="true"
          iconFolder="alert-icons/"
          (click)="view$.next('icon')"
        ></task-icon-picker-button>

        <oph-input-inside-label
          class="name-input"
          [backgroundColor]="'var(--lightest)'"
          [control]="$any(form.get('name'))"
          [label]="'Notification name'"
        ></oph-input-inside-label>
      </div>

      <!-- Alert Text Area -->
      <div class="text-area-container">
        <textarea
          class="oph-scroll-bar"
          [value]="form.get('alertText').value"
          (input)="onAlertTextChange($event)"
          maxlength="220"
          placeholder="Congrats! You've reached 100 meters!"
        ></textarea>
        <div class="character-count">{{ form.get('alertText').value?.length || 0 }}/220</div>
      </div>

      <!-- Schedule Settings -->
      <div class="section" [class.disabled]="scheduleDisabled">
        <h3 class="section-title">Alert repeats every</h3>
        <div class="row">
          <!-- Repeat Settings -->
          <div class="repeat-controls">
            <button [matMenuTriggerFor]="repeatMenu" class="repeat-button repeat-every-button">
              {{ form.get('schedule.repeatEvery').value }}
            </button>
            <mat-menu #repeatMenu="matMenu" class="oph-select-menu">
              @for (option of repeatOptions; track option) {
                <button class="oph-select-menu-item" (click)="form.get('schedule.repeatEvery').setValue(option)">
                  {{ option }}
                </button>
              }
            </mat-menu>

            <button [matMenuTriggerFor]="typeMenu" class="repeat-button repeat-type-button">
              {{ form.get('schedule.repeatType').value | titlecase }}
              <mat-icon svgIcon="chevron-down"></mat-icon>
            </button>
            <mat-menu #typeMenu="matMenu" class="oph-select-menu">
              @for (type of repeatTypeOptions; track type.value) {
                <button class="oph-select-menu-item" (click)="onRepeatTypeChange(type.value)">
                  {{ type.label }}
                </button>
              }
            </mat-menu>
          </div>

          @if (form.get('schedule.repeatType').value === 'week') {
            <span class="on-text">on</span>
            <!-- Week Selector -->
            <oph-week-selector
              [control]="$any(form.get('schedule.repeatDays'))"
              [selectedGreenBorder]="true"
            ></oph-week-selector>
          }

          <span class="at-text">at</span>

          <!-- Time Selector -->
          <button class="time-button" (click)="onTimeButtonClick()">
            <img src="assets/img/icons/clock-brown.svg" />
            {{
              form.get('schedule.alertStart').value
                ? (form.get('schedule.alertStart').value | convertUtcToTimezone: 'h:mm a')
                : 'Select Time'
            }}
          </button>
        </div>
      </div>

      <!-- Trigger Section -->
      <div class="section">
        <h3 class="section-title">Alert Trigger (optional)</h3>
        <task-trigger-selection
          [triggerFormGroup]="$any(form.get('trigger'))"
          [hideXButton]="true"
          (removeItem)="onRemoveTrigger()"
          (newClick)="$any(view$).next('trigger')"
        />
      </div>

      <!-- Action Buttons -->
      <div class="button-row">
        @if (data?.alert) {
          <oph-button class="delete-button" color="red" [loading]="loadingDelete" (click)="onDelete()">
            Delete
          </oph-button>
        }
        <oph-button
          color="gray"
          appearance="outline"
          [style]="{'border-width': '0.5px', 'border-radius': '8px'}"
          (click)="onCancel()"
          >Cancel</oph-button
        >
        <oph-button
          color="green"
          [style]="{'border-radius': '8px'}"
          [loading]="loadingSave"
          [disabled]="loadingSave || form.invalid"
          (click)="onFinish()"
          >Finish</oph-button
        >
      </div>

      <!-- Add the time selector overlay -->
      <div class="time-selector-overlay" [class.visible]="showTimeSelector">
        <div class="time-selector-modal">
          <div class="modal-header">
            <oph-x-button (click)="closeTimeSelector()"></oph-x-button>
          </div>
          <oph-time-selector
            [hoursControl]="$any(startTimeForm.get('hours'))"
            [minutesControl]="$any(startTimeForm.get('minutes'))"
            [ampmControl]="$any(startTimeForm.get('ampm'))"
          ></oph-time-selector>
        </div>
      </div>
    </div>
  }

  @if (view$.value === 'icon') {
    <div class="icon-header">
      <oph-x-button (click)="view$.next('form')"></oph-x-button>
    </div>
    <div class="icon-container">
      @for (icon of icons; track icon) {
        <button (click)="onIcon(icon)" class="icon-button">
          <oph-icon [name]="'alert-icons/' + icon" [size]="70" class="task-icon"></oph-icon>
        </button>
      }
    </div>
  }

  @if ($any(view$).value === 'trigger') {
    <new-tracker-in-dialog
      [projectId]="data.projectId"
      [hideMetricCheckboxes]="true"
      (closeNewTrackerInDialog)="onCloseNewTrackerInDialog($event?.trackerId)"
    ></new-tracker-in-dialog>
  }
}
